import { gql } from "@apollo/client";

export const addSchoolGroupQuery = gql`
mutation addSchoolGroupQuery {
  addSchoolGroup {
    id
  }
}
`;
